/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://mcdonalds-web-production-api-il-bza4dkfxa9b9bubg.israelcentral-01.azurewebsites.net/swagger/v1/swagger.json **/

import axios from "../axios"
import * as McDonalds from "./McDonaldsInterfaces"

export const getAccountGenerateVerificationCode = (
  mobilePhone: string,
  toSendSms: boolean = true
) =>
  axios.get<McDonalds.GenerateVerificationCodeResponseResponseWrapper>(
    `/api/account/generateVerificationCode`,
    { params: { mobilePhone, toSendSms } }
  )

export const getAccountUpdateLastSeen = () =>
  axios.get<McDonalds.DateTimeResponseWrapper>(`/api/account/updateLastSeen`)

export const getAccountGetUserInfo = () =>
  axios.get<McDonalds.UserInfoResponseResponseWrapper>(
    `/api/account/getUserInfo`
  )

export const postAccountRegister = (data: McDonalds.RegistrationRequest) =>
  axios.post<McDonalds.RegistrationResponseResponseWrapper>(
    `/api/account/register`,
    data
  )

export const postAccountFacebookConnect = (
  data: McDonalds.ThirdPartyConnectRequest
) =>
  axios.post<McDonalds.ThirdPartyConnectResponseResponseWrapper>(
    `/api/account/facebookConnect`,
    data
  )

export const postAccountAppleConnect = (
  data: McDonalds.ThirdPartyConnectRequest
) =>
  axios.post<McDonalds.ThirdPartyConnectResponseResponseWrapper>(
    `/api/account/appleConnect`,
    data
  )

export const postAccountVerifyUser = (data: McDonalds.VerifyUserRequest) =>
  axios.post<McDonalds.UserInfoResponseResponseWrapper>(
    `/api/account/verifyUser`,
    data
  )

export const postAccountLogout = () =>
  axios.post<McDonalds.BooleanResponseWrapper>(`/api/account/logout`)

export const getAiImageAiSetting = () =>
  axios.get<McDonalds.AiSettingDtoResponseWrapper>(`/api/aiImage/aiSetting`)

export const getAiImageGetAllBlessing = () =>
  axios.get<McDonalds.AiBlessingDtoListResponseWrapper>(
    `/api/aiImage/getAllBlessing`
  )

export const getAiImageGetAllTagCategory = (blessingId: number /* int32 */) =>
  axios.get<McDonalds.TagCategoryDtoListResponseWrapper>(
    `/api/aiImage/getAllTagCategory`,
    { params: { blessingId } }
  )

export const postAiImageGenerateAiImage = (
  data: McDonalds.GenerateAiImageRequest
) =>
  axios.post<McDonalds.AiImageDtoListResponseWrapper>(
    `/api/aiImage/generateAiImage`,
    data
  )

export const postAiImageAiImageHistory = (
  data: McDonalds.AiImageHistoryRequest
) =>
  axios.post<McDonalds.AiImageDtoListResponseWrapper>(
    `/api/aiImage/aiImageHistory`,
    data
  )

export const postApiReportGiftCards = (
  data: McDonalds.ReportGiftCardsRequest
) =>
  axios.post<McDonalds.ReportGiftCardResponseListResponseWrapper>(
    `/api/ApiReport/GiftCards`,
    data
  )

export const postApiReportGiftCardTransactions = (
  data: McDonalds.ApiReportRequest
) =>
  axios.post<McDonalds.ReportGiftCardTransactionsResponseListResponseWrapper>(
    `/api/ApiReport/GiftCardTransactions`,
    data
  )

export const postApiReportOrder = (data: McDonalds.ApiReportRequest) =>
  axios.post<McDonalds.OrderReportDtoListResponseWrapper>(
    `/api/ApiReport/Order`,
    data
  )

export const postApiReportPurches = (data: McDonalds.ApiReportRequest) =>
  axios.post<McDonalds.PurchesReportDtoListResponseWrapper>(
    `/api/ApiReport/Purches`,
    data
  )

export const postApiReportGroupPurchases = (data: McDonalds.ApiReportRequest) =>
  axios.post<McDonalds.GroupPurchasesResponseListResponseWrapper>(
    `/api/ApiReport/GroupPurchases`,
    data
  )

export const getApiReportVersion = () =>
  axios.get<any>(`/api/ApiReport/Version`)

export const postFilesDeleteFile = (fileGuid: string) =>
  axios.post<McDonalds.BooleanResponseWrapper>(`/api/Files/DeleteFile`, {
    params: { fileGuid },
  })

export const postFilesUploadVideoBlessingFile = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void
) =>
  axios.post<McDonalds.StringResponseWrapper>(
    `/api/Files/UploadVideoBlessingFile`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" }, onUploadProgress }
  )

export const getFilesGetVideoFile = (file: string) =>
  axios.get<any>(`/api/Files/GetVideoFile`, { params: { file } })

export const getSettingsAll = () =>
  axios.get<McDonalds.GeneralSettingResponseListResponseWrapper>(
    `/api/settings/all`
  )

export const getSettingsGetQuickPurchaseSettings = () =>
  axios.get<McDonalds.QuickPurchaseSettingsDtoResponseWrapper>(
    `/api/settings/getQuickPurchaseSettings`
  )

export const postGiftCardGenerateVerificationCode = (
  data: McDonalds.GenerateVerificationCodeRequest
) =>
  axios.post<McDonalds.GenerateVerificationCodeResponseResponseWrapper>(
    `/api/GiftCard/generateVerificationCode`,
    data
  )

export const postGiftCardVerifyMobilePhone = (
  data: McDonalds.VerifyUserRequest
) =>
  axios.post<McDonalds.VerifyMobileResponseResponseWrapper>(
    `/api/GiftCard/VerifyMobilePhone`,
    data
  )

export const postGiftCardGetGiftCards = () =>
  axios.post<McDonalds.GetGiftCardsResponeResponseWrapper>(
    `/api/GiftCard/GetGiftCards`
  )

export const postGiftCardGetGiftCard = (data: McDonalds.GetGiftCardModel) =>
  axios.post<McDonalds.GiftCardResponseResponseWrapper>(
    `/api/GiftCard/GetGiftCard`,
    data
  )

export const getGiftCardGetGiftCard = (giftCardGuid: string) =>
  axios.get<McDonalds.GiftCardResponseResponseWrapper>(
    `/api/GiftCard/GetGiftCard`,
    { params: { giftCardGuid } }
  )

export const getGiftCardGetBanners = () =>
  axios.get<McDonalds.BannerResponseListResponseWrapper>(
    `/api/GiftCard/GetBanners`
  )

export const getGiftCardGetCategory = () =>
  axios.get<McDonalds.CategoryResponseListResponseWrapper>(
    `/api/GiftCard/GetCategory`
  )

export const getGiftCardGetAllBlessingSlug = () =>
  axios.get<McDonalds.StringListResponseWrapper>(
    `/api/GiftCard/GetAllBlessingSlug`
  )

export const getGiftCardGetCategoriesSlug = () =>
  axios.get<McDonalds.StringListResponseWrapper>(
    `/api/GiftCard/GetCategoriesSlug`
  )

export const getGiftCardGetBlessingSlug = (slug: string) =>
  axios.get<McDonalds.BlessingResponseResponseWrapper>(
    `/api/GiftCard/GetBlessing/${slug}`
  )

export const getGiftCardGetCategorySlug = (slug: string) =>
  axios.get<McDonalds.CategoryResponseResponseWrapper>(
    `/api/GiftCard/GetCategory/${slug}`
  )

export const getGiftCardGetGiftCardSetting = () =>
  axios.get<McDonalds.GiftCardSettingModelResponseWrapper>(
    `/api/GiftCard/GetGiftCardSetting`
  )

export const postGiftCardGetPageText = (pageSystenName: string) =>
  axios.post<McDonalds.PageTextResponseListResponseWrapper>(
    `/api/GiftCard/GetPageText`,
    { params: { pageSystenName } }
  )

export const postGiftCardCalculatePrice = (
  data: McDonalds.CalculatePriceModel
) =>
  axios.post<McDonalds.CalculatePriceResponseResponseWrapper>(
    `/api/GiftCard/CalculatePrice`,
    data
  )

export const postGiftCardCreateOrder = (
  data: McDonalds.CreateGiftCardsOrderModel
) =>
  axios.post<McDonalds.CreateGiftCardsOrderResponseResponseWrapper>(
    `/api/GiftCard/CreateOrder`,
    data
  )

export const postGiftCardQuickPurchaseCreateOrder = (
  data: McDonalds.QuickPurchaseCreateOrderModel
) =>
  axios.post<McDonalds.CreateGiftCardsOrderResponseResponseWrapper>(
    `/api/GiftCard/quickPurchaseCreateOrder`,
    data
  )

export const getGiftCardGetFAQ = () =>
  axios.get<McDonalds.FaqsResponseListResponseWrapper>(`/api/GiftCard/GetFAQ`)

export const getGiftCardProperLanguagePolicy = () =>
  axios.get<McDonalds.InfoPageModelResponseWrapper>(
    `/api/GiftCard/ProperLanguagePolicy`
  )

export const getGiftCardTermsofUse = () =>
  axios.get<McDonalds.InfoPageModelResponseWrapper>(`/api/GiftCard/TermsofUse`)

export const getGiftCardAccessibilityDeclaration = () =>
  axios.get<McDonalds.InfoPageModelResponseWrapper>(
    `/api/GiftCard/AccessibilityDeclaration`
  )

export const getGiftCardClearCache = () =>
  axios.get<McDonalds.BooleanResponseWrapper>(`/api/GiftCard/ClearCache`)

export const postGiftCardGetGiftCardSchedule = (
  data: McDonalds.GetGiftCardScheduleRequest
) =>
  axios.post<McDonalds.GetGiftCardScheduleResponeResponseWrapper>(
    `/api/GiftCard/GetGiftCardSchedule`,
    data
  )

export const postGiftCardTempAddQRTogiftCard = () =>
  axios.post<any>(`/api/GiftCard/TempAddQRTogiftCard`)

export const getGiftCardTempGetQRTogiftCard = () =>
  axios.get<any>(`/api/GiftCard/TempGetQRTogiftCard`)

export const getGroupPurchaseGetGroupPurchaseSettings = () =>
  axios.get<McDonalds.GroupPurchaseSettingsDtoResponseWrapper>(
    `/api/GroupPurchase/getGroupPurchaseSettings`
  )

export const postGroupPurchaseCreateGroupPurchase = (
  data: McDonalds.CreateGroupPurchaseRequest
) =>
  axios.post<McDonalds.AddGroupPurchaseUserResponeResponseWrapper>(
    `/api/GroupPurchase/createGroupPurchase`,
    data
  )

export const postGroupPurchaseGetGroupPurchase = (
  data: McDonalds.GetGroupPurchaseDetailsRequest
) =>
  axios.post<McDonalds.GetGroupPurchaseResponeResponseWrapper>(
    `/api/GroupPurchase/getGroupPurchase`,
    data
  )

export const postGroupPurchaseGetGroupPurchaseDetails = (
  data: McDonalds.GetGroupPurchaseDetailsRequest
) =>
  axios.post<McDonalds.GetGroupPurchaseResponeResponseWrapper>(
    `/api/GroupPurchase/getGroupPurchaseDetails`,
    data
  )

export const postGroupPurchaseAddGroupPurchaseUser = (
  data: McDonalds.AddGroupPurchaseUserRequest
) =>
  axios.post<McDonalds.AddGroupPurchaseUserResponeResponseWrapper>(
    `/api/GroupPurchase/addGroupPurchaseUser`,
    data
  )

export const postGroupPurchaseAddGroupPurchaseRecipient = (
  data: McDonalds.GroupPurchaseRecipientRequest
) =>
  axios.post<McDonalds.GroupPurchaseRecipientResponseWrapper>(
    `/api/GroupPurchase/addGroupPurchaseRecipient`,
    data
  )

export const postGroupPurchaseUpdateGroupPurchaseRecipient = (
  data: McDonalds.GroupPurchaseRecipientRequest
) =>
  axios.post<McDonalds.GroupPurchaseRecipientResponseWrapper>(
    `/api/GroupPurchase/updateGroupPurchaseRecipient`,
    data
  )

export const postGroupPurchaseDeleteGroupPurchaseRecipient = (
  data: McDonalds.DeleteGroupPurchaseRecipientRequest
) =>
  axios.post<McDonalds.BooleanResponseWrapper>(
    `/api/GroupPurchase/deleteGroupPurchaseRecipient`,
    data
  )

export const getGroupPurchaseGetGroupPurchaseSharingText = (
  groupPurchaseGuid: string /* uuid */
) =>
  axios.get<McDonalds.GroupPurchaseSharingTextResponeResponseWrapper>(
    `/api/GroupPurchase/getGroupPurchaseSharingText`,
    { params: { groupPurchaseGuid } }
  )

export const postGroupPurchaseSubmitGroupPurchase = (
  data: McDonalds.SubmitGroupPurchaseRequest
) =>
  axios.post<McDonalds.GetGroupPurchaseResponeResponseWrapper>(
    `/api/GroupPurchase/submitGroupPurchase`,
    data
  )

export const postGroupPurchaseGroupPurchaseMaxPrice = (
  data: McDonalds.GroupPurchaseMaxPriceRequest
) =>
  axios.post<McDonalds.DecimalResponseWrapper>(
    `/api/GroupPurchase/groupPurchaseMaxPrice`,
    data
  )

export const getLeadLeadPageInfo = () =>
  axios.get<McDonalds.LeadInfoPageModelResponseWrapper>(
    `/api/lead/LeadPageInfo`
  )

export const getLeadLeadBanner = () =>
  axios.get<McDonalds.LeadBannerDtoResponseWrapper>(`/api/lead/LeadBanner`)

export const postLeadCreateLead = (data: McDonalds.CreateLeadRequest) =>
  axios.post<McDonalds.CreateLeadResponeResponseWrapper>(
    `/api/lead/CreateLead`,
    data
  )

export const postMCGiftCardImAlive = () =>
  axios.post<McDonalds.BooleanResponseWrapper>(`/api/MCGiftCard/ImAlive`)

export const getMCGiftCardEmailCheck = (to: string) =>
  axios.get<McDonalds.BooleanResponseWrapper>(`/api/MCGiftCard/emailCheck`, {
    params: { to },
  })

export const postMCGiftCardGetGiftCards = (
  data: McDonalds.GetGiftCardsRequestModel
) =>
  axios.post<McDonalds.McGiftCardResponseListResponseWrapper>(
    `/api/MCGiftCard/GetGiftCards`,
    data
  )

export const postMCGiftCardGetApiGiftCards = (
  data: McDonalds.GetGiftCardsRequestModel
) =>
  axios.post<McDonalds.McSlimGiftCardResponseListResponseWrapper>(
    `/api/MCGiftCard/getApiGiftCards`,
    data
  )

export const postMCGiftCardGetGiftCard = (
  data: McDonalds.GetGiftCardRequestModel
) =>
  axios.post<McDonalds.McGiftCardResponseResponseWrapper>(
    `/api/MCGiftCard/GetGiftCard`,
    data
  )

export const postMCGiftCardChargeGiftCards = (
  data: McDonalds.ChargeGiftCardsRequest
) =>
  axios.post<McDonalds.ChangeGiftCardsResponseResponseWrapper>(
    `/api/MCGiftCard/ChargeGiftCards`,
    data
  )

export const postMCGiftCardRefundTransaction = (
  data: McDonalds.RefundTransactionRequest
) =>
  axios.post<McDonalds.ChangeGiftCardsResponseResponseWrapper>(
    `/api/MCGiftCard/RefundTransaction`,
    data
  )

export const getMessagesMarkAsRead = (messageId: number /* int32 */) =>
  axios.get<McDonalds.BooleanResponseWrapper>(`/api/messages/markAsRead`, {
    params: { messageId },
  })

export const getMessagesMarkAsReadByNotification = (
  notificationId: number /* int32 */
) =>
  axios.get<McDonalds.BooleanResponseWrapper>(
    `/api/messages/markAsReadByNotification`,
    { params: { notificationId } }
  )

export const postMessagesGet = (FilterType: string) =>
  axios.post<McDonalds.MessageReponseListResponseWrapper>(`/api/messages/get`, {
    params: { FilterType },
  })

export const getOrderGetOrderVideo = (order: string, giftCardId: string) =>
  axios.get<McDonalds.OrderVideoModelResponseWrapper>(
    `/api/Order/GetOrderVideo`,
    { params: { order, giftCardId } }
  )

export const getOrderGetOrderVideoSharingText = (
  order: string,
  giftCardId: string
) =>
  axios.get<McDonalds.StringResponseWrapper>(
    `/api/Order/GetOrderVideoSharingText`,
    { params: { order, giftCardId } }
  )

export const getOrderGetOrderGiftCardSharingText = (
  orderRecipientGuid: string,
  giftCardId: string
) =>
  axios.get<McDonalds.StringResponseWrapper>(
    `/api/Order/GetOrderGiftCardSharingText`,
    { params: { orderRecipientGuid, giftCardId } }
  )

export const getOrderRecipientEmail = (order: string, giftCardId: string) =>
  axios.get<any>(`/api/Order/RecipientEmail`, { params: { order, giftCardId } })

export const getOrderSenderEmail = (order: string) =>
  axios.get<any>(`/api/Order/SenderEmail`, { params: { order } })

export const getPassV1DownloadPassTypeIdentifierIdentifier = (
  passTypeIdentifier: string,
  identifier: string
) => axios.get<any>(`/api/pass/v1/download/${passTypeIdentifier}/${identifier}`)

export const getPassV1DownloadBundlePassTypeIdentifierIdentifier = (
  passTypeIdentifier: string,
  identifier: string
) =>
  axios.get<any>(
    `/api/pass/v1/download/bundle/${passTypeIdentifier}/${identifier}`
  )

export const getPassV1GetLoyaltyPassUrl = (giftCardGuid: string) =>
  axios.get<any>(`/api/pass/v1/getLoyaltyPassUrl`, { params: { giftCardGuid } })

export const getPassV1GetOrderApplePassUrl = (orderRecipientGuid: string) =>
  axios.get<any>(`/api/pass/v1/getOrderApplePassUrl`, {
    params: { orderRecipientGuid },
  })

export const getPassV1GetGoogleLoyaltyPassUrl = (giftCardGuid: string) =>
  axios.get<any>(`/api/pass/v1/getGoogleLoyaltyPassUrl`, {
    params: { giftCardGuid },
  })

export const getPassV1GetLoyaltyPassUrlRedirect = (giftCardGuid: string) =>
  axios.get<any>(`/api/pass/v1/getLoyaltyPassUrlRedirect`, {
    params: { giftCardGuid },
  })

export const getPassV1GetGoogleLoyaltyPassUrlRedirect = (
  giftCardGuid: string
) =>
  axios.get<any>(`/api/pass/v1/getGoogleLoyaltyPassUrlRedirect`, {
    params: { giftCardGuid },
  })

export const getPassV1GetGoogleOrderPassUrl = (orderRecipientGuid: string) =>
  axios.get<any>(`/api/pass/v1/getGoogleOrderPassUrl`, {
    params: { orderRecipientGuid },
  })

export const getPassV1GiftCardUpdate = (giftCardGuid: string, order: string) =>
  axios.get<any>(`/api/pass/v1/giftCardUpdate`, {
    params: { giftCardGuid, order },
  })

export const getPassV1Update = () => axios.get<any>(`/api/pass/v1/update`)

export const getPassbookDownloadPassTypeIdentifierSerialNumberValidityValidationHash =
  (
    passTypeIdentifier: string,
    serialNumber: string,
    validity: string,
    validationHash: string
  ) =>
    axios.get<any>(
      `/api/passbook/download/${passTypeIdentifier}/${serialNumber}/${validity}/${validationHash}`
    )

export const getPassbookDownloadBundlePassTypeIdentifierSerialNumberValidityValidationHash =
  (
    passTypeIdentifier: string,
    serialNumber: string,
    validity: string,
    validationHash: string
  ) =>
    axios.get<any>(
      `/api/passbook/download/bundle/${passTypeIdentifier}/${serialNumber}/${validity}/${validationHash}`
    )

export const postV1DevicesDeviceLibraryIdentifierRegistrationsPassTypeIdentifierSerialNumber =
  (
    deviceLibraryIdentifier: string,
    passTypeIdentifier: string,
    serialNumber: string
  ) =>
    axios.post<any>(
      `/v1/devices/${deviceLibraryIdentifier}/registrations/${passTypeIdentifier}/${serialNumber}`
    )

export const deleteV1DevicesDeviceLibraryIdentifierRegistrationsPassTypeIdentifierSerialNumber =
  (
    deviceLibraryIdentifier: string,
    passTypeIdentifier: string,
    serialNumber: string
  ) =>
    axios.delete<any>(
      `/v1/devices/${deviceLibraryIdentifier}/registrations/${passTypeIdentifier}/${serialNumber}`
    )

export const getV1DevicesDeviceLibraryIdentifierRegistrationsPassTypeIdentifier =
  (
    deviceLibraryIdentifier: string,
    passTypeIdentifier: string,
    passesUpdatedSince: string
  ) =>
    axios.get<any>(
      `/v1/devices/${deviceLibraryIdentifier}/registrations/${passTypeIdentifier}`,
      { params: { passesUpdatedSince } }
    )

export const getV1PassesPassTypeIdentifierSerialNumber = (
  passTypeIdentifier: string,
  serialNumber: string
) => axios.get<any>(`/v1/passes/${passTypeIdentifier}/${serialNumber}`)

export const postV1Log = (logs: string[]) =>
  axios.post<any>(`/v1/log`, { params: { logs } })

export const getPaymentPaymentMethods = (
  orderId: number /* int32 */,
  browser: string,
  groupPurchaseUserGuid: string /* uuid */
) =>
  axios.get<McDonalds.PaymentMethodsDtoResponseWrapper>(
    `/api/Payment/paymentMethods`,
    { params: { orderId, browser, groupPurchaseUserGuid } }
  )

export const getPaymentGetPayUrl = (
  orderId: number /* int32 */,
  browser: string
) =>
  axios.get<McDonalds.StringResponseWrapper>(`/api/Payment/getPayUrl`, {
    params: { orderId, browser },
  })

export const getPaymentGetWalletURL = (
  orderId: number /* int32 */,
  browser: string
) =>
  axios.get<McDonalds.StringResponseWrapper>(`/api/Payment/getWalletURL`, {
    params: { orderId, browser },
  })

export const postPaymentPaymentDone = (
  formData: FormData,
  onUploadProgress?: (progressEvent: any) => void
) =>
  axios.post<any>(`/api/Payment/paymentDone`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
  })

export const getPaymentGetBit = (
  orderId: number /* int32 */,
  browser: string
) =>
  axios.get<McDonalds.BitResponseResponseWrapper>(`/api/Payment/getBit`, {
    params: { orderId, browser },
  })

export const postPaymentPaymentDoneBit = (
  data: McDonalds.PaymentDoneBitRequest
) =>
  axios.post<McDonalds.PaymentDoneModelResponseWrapper>(
    `/api/Payment/paymentDoneBit`,
    data
  )

export const postPaymentGetGroupPurchasePayUrl = (
  data: McDonalds.GroupPurchasePayUrlRequeste
) =>
  axios.post<McDonalds.GroupPurchasePayUrlResponeResponseWrapper>(
    `/api/Payment/getGroupPurchasePayUrl`,
    data
  )

export const postPaymentGetGroupPurchaseWalletURL = (
  data: McDonalds.GroupPurchasePayUrlRequeste
) =>
  axios.post<McDonalds.GroupPurchasePayUrlResponeResponseWrapper>(
    `/api/Payment/getGroupPurchaseWalletURL`,
    data
  )

export const postPaymentGetGroupPurchaseBit = (
  data: McDonalds.GroupPurchasePayUrlRequeste
) =>
  axios.post<McDonalds.GroupPurchaseBitResponseResponseWrapper>(
    `/api/Payment/getGroupPurchaseBit`,
    data
  )
